import type { ThemeComponents, ThemeSettings } from '../../types';

export const getSharedTableStyles = (
  components: ThemeComponents,
  {
    palette,
  }: ThemeSettings
) => ({
  '&': {
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
  },

  '& .glyphicon': {
    position: 'static',
  },

  '& .iconba': {
    position: 'static',
  },

  '& .grid-disabled': {
    color: palette.neutralSecondaryAlt,
  },
});
